/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelRateStreamErrorCode } from './HotelRateStreamErrorCode';
import {
    HotelRateStreamErrorCodeFromJSON,
    HotelRateStreamErrorCodeFromJSONTyped,
    HotelRateStreamErrorCodeToJSON,
    HotelRateStreamErrorCodeToJSONTyped,
} from './HotelRateStreamErrorCode';

/**
 * Terminal error event. The stream closes immediately after this fires.
 * 
 * @export
 * @interface HotelRateStreamError
 */
export interface HotelRateStreamError {
    /**
     * 
     * @type {string}
     * @memberof HotelRateStreamError
     */
    type: HotelRateStreamErrorTypeEnum;
    /**
     * 
     * @type {HotelRateStreamErrorCode}
     * @memberof HotelRateStreamError
     */
    code: HotelRateStreamErrorCode;
    /**
     * 
     * @type {string}
     * @memberof HotelRateStreamError
     */
    message: string;
}


/**
 * @export
 */
export const HotelRateStreamErrorTypeEnum = {
    Error: 'error'
} as const;
export type HotelRateStreamErrorTypeEnum = typeof HotelRateStreamErrorTypeEnum[keyof typeof HotelRateStreamErrorTypeEnum];


/**
 * Check if a given object implements the HotelRateStreamError interface.
 */
export function instanceOfHotelRateStreamError(value: object): value is HotelRateStreamError {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function HotelRateStreamErrorFromJSON(json: any): HotelRateStreamError {
    return HotelRateStreamErrorFromJSONTyped(json, false);
}

export function HotelRateStreamErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelRateStreamError {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'code': HotelRateStreamErrorCodeFromJSON(json['code']),
        'message': json['message'],
    };
}

export function HotelRateStreamErrorToJSON(json: any): HotelRateStreamError {
    return HotelRateStreamErrorToJSONTyped(json, false);
}

export function HotelRateStreamErrorToJSONTyped(value?: HotelRateStreamError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'code': HotelRateStreamErrorCodeToJSON(value['code']),
        'message': value['message'],
    };
}

